import { Directive, HostListener, Input, Optional, ElementRef, OnInit } from '@angular/core';

import { BllDialogRef } from './dialog-ref';
import { BllDialogService } from './dialog.service';

@Directive({
  selector: '[bllDialogClose]',
})
export class BllDialogCloseDirective implements OnInit {
  @Input('bllDialogClose') dialogClose: any;

  constructor(
    @Optional() public ref: BllDialogRef,
    private host: ElementRef<HTMLElement>,
    private dialogService: BllDialogService
  ) {}

  ngOnInit(): void {
    this.ref = this.ref || this.getRefFromParent();
  }

  @HostListener('click')
  onClose() {
    this.ref.close(this.dialogClose);
  }

  private getRefFromParent() {
    let parent = this.host.nativeElement.parentElement;

    while (parent && parent.localName !== 'bll-dialog') {
      parent = parent.parentElement;
    }

    return parent ? this.dialogService.dialogs.find(({ id }) => id === parent.id) : null;
  }
}
